import { useState, useEffect } from "react";
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import {BannerOnclick,GetBanners} from "@/app/utils/class/cms/banner"

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../../style/topBanner.scss';
import { LANGTYPE_EN, useLanguage } from "@/app/utils/LanguageContext";
import { useMyContext } from "@/app/utils/MyContext";
import { adobeData, generateAdobeDataRaceNo } from "@/app/utils/Common";

const TopBanner = (props: any)=>{
  const {isMobile} = props
  const [bannerArr, setBannerArr] = useState<BannerData[]>([])
  const { state: lang } = useLanguage();
  useEffect(() => { 
    GetBanners(lang.langCode,"Top",(enableBannerList:BannerData[])=>{
      setBannerArr(enableBannerList)
    }, isMobile)
    
  }, []);

  const canShow=bannerArr?.length>0
  return(
    canShow&&<div className="swiper-container" id="race_top_banner_container" style={{marginTop: isMobile ? 10 : 0}}>
        <Banner isMobile={isMobile} bannerArr={bannerArr} limit={10}/>    
    </div>
  )
}

const Banner = (props: any) => {
  const {isMobile,bannerArr,limit} = props;
  const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
  const { state: lang } = useLanguage();

  const pagination={
    el: '.bannerPagination',
    clickable:true,
    renderBullet: (index: number, className: string) => {
      if (index >= bannerArr.length) return ''; //
      return `<span class="${className}"></span>`;
    }
  }
  const autoplay={
    delay: 3000
  }
  const loop=bannerArr.length>1?true:false
  const swiperClassName=isMobile?"MobileSwiper":"PCSwiper"
  const swiperSlideName=isMobile?"MobileSwiperSlide":"PCSwiperSlide"
  const isOnePicture=!loop

  const handleBannerClick = (banner: BannerData) => {
    adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
      pageId: "racing/simulcast",
      internalAd: "SPLDSP_racing/simulcast_TopBanner",
      eventId: "racing/simulcast_ClickBanner_AnyPage_TopBanner",
      raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo?.valueOf())
    });
    BannerOnclick(banner, "TopBanner");
  }
  // if bannerArr size is too small, will loop incorrectly
  const getbannerArr=() => bannerArr.length>1 && bannerArr.length < 4 ? [...bannerArr, ...bannerArr] : bannerArr
  return (
    <div className="topbannerswiper">
      <Swiper 
        slidesPerView={'auto'}
        centeredSlides={true}
        spaceBetween={8}
        className={swiperClassName}
        modules={[Pagination,Navigation,Autoplay]} 
        pagination={isMobile?pagination:false}
        navigation={isMobile?false:true}
        autoplay={autoplay}        
        loop={loop}
        onSlideChange={(swiper) => {
        const correctIndex = swiper.realIndex%bannerArr?.length;
        const pagination_dot = (document.querySelector(".bannerPagination") as any)?.childNodes;
        if(isMobile && pagination_dot) {
          for (let index = 0; index < pagination_dot.length; index++) {
            const element = pagination_dot[index];
            if (correctIndex == index) {
              element.classList.add("swiper-pagination-bullet-active");
            }else {
              element.classList.remove("swiper-pagination-bullet-active");
            }
          }
        }
      }}
      >
        
        {getbannerArr()?.map((banner:BannerData,index:number)=>{
          return (
            index < limit && <SwiperSlide className={swiperSlideName} key={index} style={isOnePicture ? { width: "calc(100% - 32px)" } : {}}>
              <img src={isMobile? banner.imageUrl_Mobile?.value || banner.imageUrl.value: banner.imageUrl.value} className={banner.redirectionLink.value && "clickable"} onClick={() => handleBannerClick(banner)} />
            </SwiperSlide>
            )
          })
        }                
      </Swiper>
      {isMobile&&!isOnePicture&&<div className="bannerPagination"></div>}
  </div>
  );  
}

export {
  TopBanner,
  Banner
}